import axios from "axios";
import { store } from "store";
import { logout } from "store/slices/authSlice";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL ?? "http://localhost:3001/api/v1",
  headers: { "Content-Type": "application/json" },
});

// Attach JWT token to every request.
// For FormData bodies, remove the default Content-Type so the browser can set
// multipart/form-data with the correct boundary automatically.
apiClient.interceptors.request.use((config) => {
  const token = store.getState().auth.token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  }
  return config;
});

// Auto-logout on 401
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      store.dispatch(logout());
    }
    return Promise.reject(error);
  }
);

export default apiClient;
